export const SET_ER_RESPONSE = 'SET_ER_RESPONSE';
export const GET_EMAIL_RESTRICTION_DATA = 'GET_EMAIL_RESTRICTION_DATA';
